(function () {
  const wishlistStorageKey = "bouquetLilleWishlist";
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function safePath(value, fallback) {
    if (!value) return fallback || "/collections/all";
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return fallback || "/collections/all";
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return fallback || "/collections/all";
    }
  }

  function safeImage(value) {
    if (!value) return "";
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== "http:" && url.protocol !== "https:") return "";
      return url.href;
    } catch (error) {
      return "";
    }
  }

  function formatMoney(cents) {
    const amount = Number(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && Number.isFinite(amount)) {
      return window.Shopify.formatMoney(amount);
    }
    if (!Number.isFinite(amount)) return "";
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(amount / 100);
  }

  function readWishlist() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(wishlistStorageKey) || "[]");
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item) => ({
          id: String(item.id || item.handle || "").trim(),
          handle: String(item.handle || "").trim(),
          title: String(item.title || "Bouquet").trim(),
          url: safePath(item.url, item.handle ? `/products/${item.handle}` : "/collections/all"),
          image: safeImage(item.image),
          price: String(item.price || "").trim(),
        }))
        .filter((item) => item.id && item.title);
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(wishlistStorageKey, JSON.stringify(items.slice(0, 80)));
    } catch (error) {
      // Browsers can block localStorage in strict private mode.
    }
  }

  async function hydrateWishlistItem(item) {
    if (!item.handle) return item;

    try {
      const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return item;
      const product = await response.json();
      const image = product.featured_image || product.images?.[0] || item.image;
      return {
        ...item,
        id: String(product.id || item.id),
        handle: product.handle || item.handle,
        title: product.title || item.title,
        url: `/products/${product.handle || item.handle}`,
        image: safeImage(image),
        price: formatMoney(product.price_min || product.price) || item.price,
        variants: Array.isArray(product.variants) ? product.variants : [],
        available: Boolean(product.available),
      };
    } catch (error) {
      return item;
    }
  }

  function setWishlistStatus(page, message) {
    const status = page.querySelector("[data-pages-wishlist-status]");
    if (status) status.textContent = message || "";
  }

  function updateCartBubble(count) {
    document.querySelectorAll(".cart-count-bubble span").forEach((node) => {
      node.textContent = String(count);
    });
  }

  async function addVariantToCart(variantId, page) {
    if (!variantId) return;
    setWishlistStatus(page, "Ajout au panier...");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (!response.ok) throw new Error("Cart add failed");

      const cartResponse = await fetch("/cart.js", { credentials: "same-origin" });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        updateCartBubble(cart.item_count || 0);
      }
      setWishlistStatus(page, "Bouquet ajoute au panier.");
    } catch (error) {
      setWishlistStatus(page, "Impossible d'ajouter ce bouquet. Ouvrez la fiche produit pour finaliser.");
    }
  }

  function createWishlistCard(item, page) {
    const card = document.createElement("article");
    card.className = "bouquet-wishlist-card bouquet-card";

    const mediaLink = document.createElement("a");
    mediaLink.className = "bouquet-wishlist-card__media";
    mediaLink.href = safePath(item.url, page.dataset.fallbackUrl || "/collections/all");
    mediaLink.setAttribute("aria-label", item.title);

    if (item.image) {
      const image = document.createElement("img");
      image.src = item.image;
      image.alt = item.title;
      image.loading = "lazy";
      mediaLink.appendChild(image);
    } else {
      mediaLink.textContent = "Bouquet Lille";
    }

    const body = document.createElement("div");
    body.className = "bouquet-wishlist-card__body";

    const title = document.createElement("h2");
    const titleLink = document.createElement("a");
    titleLink.href = mediaLink.href;
    titleLink.textContent = item.title;
    title.appendChild(titleLink);

    const price = document.createElement("p");
    price.className = "bouquet-wishlist-card__price";
    price.textContent = item.price || "";

    const actions = document.createElement("div");
    actions.className = "bouquet-wishlist-card__actions";

    const singleVariant = item.variants && item.variants.length === 1 ? item.variants[0] : null;
    if (singleVariant && singleVariant.available !== false) {
      const addButton = document.createElement("button");
      addButton.className = "bouquet-button bouquet-button--primary";
      addButton.type = "button";
      addButton.textContent = "Ajouter au panier";
      addButton.addEventListener("click", () => addVariantToCart(singleVariant.id, page));
      actions.appendChild(addButton);
    } else {
      const productLink = document.createElement("a");
      productLink.className = "bouquet-button bouquet-button--primary";
      productLink.href = mediaLink.href;
      productLink.textContent = "Voir le produit";
      actions.appendChild(productLink);
    }

    const removeButton = document.createElement("button");
    removeButton.className = "bouquet-wishlist-card__remove";
    removeButton.type = "button";
    removeButton.textContent = "Supprimer";
    removeButton.addEventListener("click", () => {
      writeWishlist(readWishlist().filter((savedItem) => savedItem.id !== item.id));
      renderWishlistPages(document);
      document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
        if (button.dataset.productId !== item.id) return;
        button.classList.remove("is-active");
        button.setAttribute("aria-pressed", "false");
      });
    });
    actions.appendChild(removeButton);

    body.append(title, price, actions);
    card.append(mediaLink, body);
    return card;
  }

  async function renderWishlistPage(page) {
    const grid = page.querySelector("[data-pages-wishlist-grid]");
    const empty = page.querySelector("[data-pages-wishlist-empty]");
    const count = page.querySelector("[data-pages-wishlist-count]");
    if (!grid || !empty) return;

    const storedItems = readWishlist();
    count.textContent = `${storedItems.length} bouquet${storedItems.length > 1 ? "s" : ""}`;
    grid.innerHTML = "";

    if (!storedItems.length) {
      empty.hidden = false;
      grid.hidden = true;
      setWishlistStatus(page, "");
      return;
    }

    empty.hidden = true;
    grid.hidden = false;
    setWishlistStatus(page, "Chargement de vos favoris...");

    const items = await Promise.all(storedItems.map(hydrateWishlistItem));
    items.forEach((item) => grid.appendChild(createWishlistCard(item, page)));
    setWishlistStatus(page, "");
  }

  function renderWishlistPages(root) {
    root.querySelectorAll("[data-pages-wishlist-page]").forEach(renderWishlistPage);
  }

  function initFaq(root) {
    root.querySelectorAll("[data-bouquet-faq]").forEach((section) => {
      if (section.dataset.faqReady === "true") return;
      section.dataset.faqReady = "true";

      const search = section.querySelector("[data-faq-search]");
      const categoryButtons = Array.from(section.querySelectorAll("[data-faq-category]"));
      const items = Array.from(section.querySelectorAll("[data-faq-item]"));
      const empty = section.querySelector("[data-faq-empty]");
      let activeCategory = "toutes";

      function applyFilters() {
        const query = (search?.value || "").trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const matchesCategory = activeCategory === "toutes" || item.dataset.category === activeCategory;
          const matchesSearch = !query || (item.dataset.searchText || "").includes(query);
          const visible = matchesCategory && matchesSearch;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount > 0;
      }

      categoryButtons.forEach((button) => {
        button.addEventListener("click", () => {
          activeCategory = button.dataset.faqCategory || "toutes";
          categoryButtons.forEach((categoryButton) => {
            const isActive = categoryButton === button;
            categoryButton.classList.toggle("is-active", isActive);
            categoryButton.setAttribute("aria-pressed", String(isActive));
          });
          applyFilters();
        });
      });

      section.querySelectorAll("[data-faq-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const panel = document.getElementById(button.getAttribute("aria-controls"));
          const isOpen = button.getAttribute("aria-expanded") === "true";
          button.setAttribute("aria-expanded", String(!isOpen));
          if (panel) panel.hidden = isOpen;
        });
      });

      search?.addEventListener("input", applyFilters);
      applyFilters();
    });
  }

  function initBlog(root) {
    root.querySelectorAll("[data-bouquet-blog]").forEach((section) => {
      if (section.dataset.blogReady === "true") return;
      section.dataset.blogReady = "true";

      const search = section.querySelector("[data-blog-search]");
      const filterButtons = Array.from(section.querySelectorAll("[data-blog-filter]"));
      const cards = Array.from(section.querySelectorAll("[data-blog-card]"));
      const empty = section.querySelector("[data-blog-empty]");
      let activeTag = "all";

      function applyFilters() {
        const query = (search?.value || "").trim().toLowerCase();
        let visibleCount = 0;

        cards.forEach((card) => {
          const tags = card.dataset.blogTags || "";
          const text = card.dataset.blogText || "";
          const matchesTag = activeTag === "all" || tags.includes(activeTag);
          const matchesSearch = !query || text.includes(query);
          const visible = matchesTag && matchesSearch;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount > 0;
      }

      filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          activeTag = button.dataset.blogFilter || "all";
          filterButtons.forEach((filterButton) => {
            const isActive = filterButton === button;
            filterButton.classList.toggle("is-active", isActive);
            filterButton.setAttribute("aria-pressed", String(isActive));
          });
          applyFilters();
        });
      });

      search?.addEventListener("input", applyFilters);
      applyFilters();
    });
  }

  function initCopyLinks(root) {
    root.querySelectorAll("[data-copy-link]").forEach((button) => {
      if (button.dataset.copyReady === "true") return;
      button.dataset.copyReady = "true";
      const initialText = button.textContent;

      button.addEventListener("click", async () => {
        const value = button.dataset.copyLink || window.location.href;
        try {
          await navigator.clipboard.writeText(value);
          button.textContent = "Lien copie";
        } catch (error) {
          window.prompt("Copiez le lien de l'article", value);
          button.textContent = "Lien pret";
        }
        window.setTimeout(() => {
          button.textContent = initialText;
        }, 1800);
      });
    });
  }

  function initPageMotion(root) {
    if (reduceMotion || !window.gsap) return;
    root.querySelectorAll("[data-pages-animate]").forEach((element) => {
      if (element.dataset.pagesAnimated === "true") return;
      element.dataset.pagesAnimated = "true";
      window.gsap.from(element.querySelectorAll(".bouquet-hero, .bouquet-card, .bouquet-blog-card, .bouquet-faq__item"), {
        autoAlpha: 0,
        y: 24,
        duration: 0.7,
        ease: "power2.out",
        stagger: 0.07,
      });
    });
  }

  function init(root) {
    initFaq(root);
    initBlog(root);
    initCopyLinks(root);
    renderWishlistPages(root);
    initPageMotion(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  window.addEventListener("storage", (event) => {
    if (event.key === wishlistStorageKey) renderWishlistPages(document);
  });
})();
